module.exports = __webpack_public_path__ + "fonts/CalibreThinItalic.e0c4ddcc.woff";